module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.1f417e0e.png";